import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import styles from './CloseConfirmationModal.module.scss'

const propTypes = {
  /**
   * If true, will display the popup
   */
  show: PropTypes.bool,
  /**
   * Callback to close the modal confirmation modal
   */
  onHideConfirmation: PropTypes.func.isRequired,
  /**
   * Callback to close the parent modal
   */
  onHideParentModal: PropTypes.func.isRequired,
  /**
   * If present will set the body content of the modal, defaults to
   * formatted messages: GENERAL.UNSAVED_PROGRESS_LOST  + GENERAL.ARE_YOU_SURE_2
   */
  bodyText: PropTypes.string,
  /**
   * If present will set the text of the "Exit" button, defaults to
   * formatted message: GENERAL.EXIT_WITHOUT_SAVING
   */
  closeButtonText: PropTypes.string,
}

function CloseConfirmationModal(props) {
  const { show = false, onHideConfirmation, onHideParentModal, bodyText = null, closeButtonText = null } = props ?? {}

  return (
    <Modal
      size="sm"
      backdrop
      centered
      className={clsx({ in: show }, styles.modalSmall)}
      show={show}
      onHide={onHideConfirmation}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="POLICY_TEMPLATES.ARE_YOU_SURE" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="unstyled-modal text-color-default text-bold">
        {bodyText ? (
          <p>{bodyText}</p>
        ) : (
          <>
            <FormattedMessage id="GENERAL.UNSAVED_PROGRESS_LOST" />
            &nbsp;
            <FormattedMessage id="GENERAL.ARE_YOU_SURE_2" />
          </>
        )}
      </Modal.Body>
      <Modal.Footer className={clsx('d-flex', 'justify-content-between')}>
        <Button variant="secondary" onClick={onHideConfirmation} id="close-button" className="me-3">
          <FormattedMessage id="GENERAL.CANCEL" />
        </Button>
        <Button
          id="confirm-button"
          variant="danger"
          onClick={() => {
            onHideConfirmation()
            onHideParentModal()
          }}
        >
          {closeButtonText ? <div>{closeButtonText}</div> : <FormattedMessage id="GENERAL.EXIT_WITHOUT_SAVING" />}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

CloseConfirmationModal.propTypes = propTypes

export default CloseConfirmationModal
